// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__qHc4u","label":"styles_label__H1IqZ","icon":"styles_icon__5P_tG"};